(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("dsAccessibility", [], factory);
	else if(typeof exports === 'object')
		exports["dsAccessibility"] = factory();
	else
		root["dsAccessibility"] = factory();
})(self, () => {
return 